import Main from './OrganizationsMain'
import New from './OrganizationsNew'
import Edit from './OrganizationsEdit'

const Organizations = {
  Main,
  New,
  Edit,
}

export default Organizations
